import { useErrorNotification } from '@/hooks/use-error-notification';
import type { NormalizedError } from '@/utils/error-utils';

export const useSimulationErrorNotification = () => {
  const showErrorNotification = useErrorNotification();

  return (error: NormalizedError, action: string) => {
    if (error.status === 403) {
      showErrorNotification(
        {
          ...error,
          message:
            'You do not have permission to perform this action. Please contact your administrator if you believe this is an error.',
        },
        action,
      );
      return;
    }
    showErrorNotification(error, action);
  };
};
